import React from 'react';
import { Colors, HorizontalOptionButton } from 'library';
import JobFormPage from './JobFormPage';
import { useJobFormContext } from 'parent-portal/forms/JobFormContext';
import { BusinessJobTypes, JobFormFields } from 'parent-portal/forms/JobRequestTypes';
import { FieldStates } from '../FormTypes';
import FormField from '../FormField';
import { Grid, useMediaQuery } from '@material-ui/core';
import { OptionType, usePaymentOptions } from 'parent-portal/payments/PaymentOptions';
import theme from 'theme';

export default function BusinessPaymentModelPage({ fieldStates }: { fieldStates: FieldStates<JobFormFields> }) {
    const { goToNext } = useJobFormContext();
    const { businessJobType, multipleProviders, endDate } = fieldStates;
    const paymentOptions = usePaymentOptions();
    const xsDown = useMediaQuery(theme.breakpoints.down('xs'));

    if (businessJobType.value) businessJobType.setValid(true);

    const onChange = (value: BusinessJobTypes) => {
        if (value === 'SUBSTITUTE') {
            businessJobType.setValue(value);
            multipleProviders.setValue(true);
        } else {
            businessJobType.setValue(value);
            multipleProviders.setValue(false);
            endDate.setValue(null);
        }
        businessJobType.setValid(true);
    };

    function backgroundColor(type: string) {
        return type === businessJobType.value ? Colors.lightTurq : Colors.white;
    }

    return (
        <JobFormPage
            title="Let's create your job."
            onNextClicked={goToNext}
            backText="Cancel"
            nextDisabled={!businessJobType.isValid}
        >
            <FormField title="What can we help you with today?" style={{ marginTop: 20 }}>
                <Grid container item direction="row" justify="space-between" style={{ marginTop: 20 }}>
                    {paymentOptions.map((o: OptionType) => (
                        <HorizontalOptionButton
                            key={o.option}
                            title={o.title}
                            subtitle={o.subtitle}
                            highlight={o.highlight}
                            listItems={o.listItems}
                            action={() => onChange(o.option as BusinessJobTypes)}
                            style={{
                                backgroundColor: backgroundColor(o.option),
                                marginLeft: 10,
                                marginRight: 10,
                                maxWidth: xsDown ? '95%' : '45%',
                            }}
                            icon={o.icon}
                        />
                    ))}
                </Grid>
            </FormField>
        </JobFormPage>
    );
}
